module.exports = __webpack_public_path__ + "static/img/lj_01.bcad533.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lj_01.jpg
// module id = Pe8I
// module chunks = 1